import gql from "graphql-tag";

export const UPDATE_DEAL_MUTATION = gql`
  mutation upsertDealMutation ($data: UpdateDealInput!){
    upsertDealMutation(data: $data) {
      success
    }
  }
`;

export const DELETE_DEAL_CALL_MUTATION = gql`
  mutation deleteDealCallMutation($callId: ID!) {
    deleteDealCallMutation(callId: $callId) {
      success
    }
  }
`;

export const CREATE_DEAL_CALL_MUTATION = gql`
  mutation createDealCallMutation($data: CreateDealCallInput!) {
    createDealCallMutation(data: $data) {
      success
    }
  }
`;

export const UPDATE_DEAL_CALL_MUTATION = gql`
  mutation updateDealCallMutation($data: UpdateDealCallInput!) {
    updateDealCallMutation(data: $data) {
      success
    }
  }
`;

export const DELETE_DEAL_MUTATION = gql`
  mutation deleteDealMutation($dealId: ID!) {
    deleteDealMutation(dealId: $dealId) {
      success
    }
  }
`;

export const UPDATE_DEAL_CONTACT_MUTATION = gql`
  mutation updateDealContactMutation($data: UpdateDealContactInput!) {
    updateDealContactMutation(data: $data) {
      success
      error
    }
  }
`;